<template>
  <div>
    <Loading :loading="this.loading"></Loading>
    <div v-show="!this.loading" class="content-wrapper bg-light-blue-violet font-family-noto-sans-jp" v-bind:class="{ modal_open: modalActive }">
      <div class="store-selector-wrapper" @click="openSSSelector">
        <div class="store-selector-content">
          <div class="store-selector-icon">
            <div class="store-selector-icon-circle">
              <span class="store-selector-icon-text">
                <span>店舗</span>
                <span>選択</span>
              </span>
            </div>
          </div>
          <div class="store-selector-name">
            <span class="store-selector-name-text" :class="getStoreNameClass">
              {{ this.bestMySS?.name || '' }}
            </span>
            <img class="store-selector-name-down-arrow" src="/lib/images/down_arrow.svg" alt="down_arrow">
          </div>
        </div>
      </div>
      <!-- ---------- 洗車対応点の場合 ---------- -->
      <div v-if="this.isCarwashSupported">
        <!-- ---------- メアド登録済みの場合 ---------- -->
        <div v-if="this.isEmailRegistered">
          <!-- ---------- 初回特典がOFFか初回特典受領済みの場合 ---------- -->
          <div v-if="!this.isAvailableInitialBenefit">
            <div class="initial-benefit-used-wrapper">
              <div class="initial-benefit-used-content">
                <div class="initial-benefit-used-header">
                  <p class="initial-benefit-used-content-title">残高</p>
                  <div class="prepaid-card-number" v-if="this.prepaidCard.card_info.card_no">
                    <span class="prepaid-card-number-text">プリカNO：{{ this.prepaidCard.card_info.card_no }}</span>
                  </div>
                </div>
                <div class="initial-benefit-used-content-balance-wrapper">
                  <span class="initial-benefit-used-content-balance-number">{{$filters.addComma(this.prepaidCard.card_info.value_amount_sum)}}</span>
                  <span class="initial-benefit-used-content-balance-unit">円分</span>
                </div>
                <div class="initial-benefit-used-content-note-wrapper">
                  <p class="initial-benefit-used-content-note-text" v-if="this.nearestLimitValueDate !== null">{{dateFormat(this.nearestLimitValueDate)}}まで有効な残高があります</p>
                </div>
                <div class="initial-benefit-used-store-type-wrapper">
                  <span class="initial-benefit-used-store-type-text">{{ this.storeType }}</span>
                </div>
                <div class="initial-benefit-used-button-wrapper">
                  <button v-if="this.prepaidCard.card_info.value_amount_sum > 0" class="initial-benefit-used-button-use-enabled" v-bind:disabled="processing" v-on:click="openQR()">
                    <img src="/lib/images/enabled-qr-icon.svg" alt="enabled-qr-icon">
                    <span>使用する</span>
                  </button>
                  <button v-else class="initial-benefit-used-button-use-disabled" disabled>
                    <img src="/lib/images/disabled-qr-icon.svg" alt="disabled-qr-icon">
                    <span>使用する</span>
                  </button>
                  <button v-if="this.ssInfo.carwash_charge_discontinued_flag === 0" class="initial-benefit-used-button-charge" v-bind:disabled="processing" v-on:click="nextPage()">
                    <img src="/lib/images/add-icon.svg" alt="add-icon">
                    <span>残高チャージ</span>
                  </button>
                  <button v-if="this.ssInfo.carwash_charge_discontinued_flag === 1" class="initial-benefit-used-button-charge-disabled" disabled>
                    <img src="/lib/images/add-disabled-icon.svg" alt="add-disabled-icon">
                    <span>残高チャージ</span>
                  </button>
                  <button class="card-edit-button" v-bind:disabled="processing" v-on:click="doEdit()">
                    <span>登録カード更新</span>
                  </button>
                  <p class="text-center mt8 fs14" v-if="this.ssInfo.carwash_charge_discontinued_flag === 1">現在このSSでは新規にチャージができません。</p>
                </div>
              </div>
            </div>
            <!-- ---------- 有効期限 ---------- -->
            <div class="limit-and-history-wrapper">
              <div class="limit-and-history-content">
                <p class="limit-and-history-title">有効期限</p>
                <div>
                  <!-- カード: あり、データ: あり -->
                  <template v-if="this.prepaidCardList.length">
                    <!-- もっと見る 前 最大 3 件 -->
                    <template v-if="!this.isShowMorePrepaidCardList">
                      <template v-for="(item, i) in this.prepaidCardMinimumList" :key="i">
                        <div :class="[
                          { 'limit-item-wrapper': i !== this.prepaidCardMinimumList.length - 1 },
                          { 'limit-item-last-wrapper': i === this.prepaidCardMinimumList.length - 1 }
                        ]">
                          <div class="limit-and-history-item-content">
                            <span class="limit-and-history-item-text-date">{{dateFormat(item.value_expire_datetime)}}（あと{{daysRemaining(item.value_expire_datetime)}}日）</span>
                            <span class="limit-and-history-item-text-value">{{$filters.addComma(item.value_amount)}}円分</span>
                          </div>
                          <div v-if="expireWarning(item.value_expire_datetime)"><span class="limit-and-history-item-text-warning">有効期限が近づいています</span></div>
                        </div>
                      </template>
                    </template>
                    <template v-else>
                      <!-- もっと見る 後 全部表示 -->
                      <template v-for="(item, i) in this.prepaidCardList" :key="'0'+i">
                        <div :class="[
                          { 'limit-item-wrapper': i !== this.prepaidCardList.length - 1 },
                          { 'limit-item-last-wrapper': i === this.prepaidCardList.length - 1 }
                        ]">
                          <div class="limit-and-history-item-content">
                            <span class="limit-and-history-item-text-date">{{dateFormat(item.value_expire_datetime)}}（あと{{daysRemaining(item.value_expire_datetime)}}日）</span>
                            <span class="limit-and-history-item-text-value">{{$filters.addComma(item.value_amount)}}円分</span>
                          </div>
                          <div v-if="expireWarning(item.value_expire_datetime)"><span class="limit-and-history-item-text-warning">有効期限が近づいています</span></div>
                        </div>
                      </template>
                    </template>
                    <div class="show-more-wrapper" v-if="showMorePrepaidCardList" v-show="!this.isShowMorePrepaidCardList">
                      <button class="limit-show-more-button" v-on:click="doShowMorePrepaidCardList()">もっと見る</button>
                      <img src="/lib/images/down_arrow.svg" alt="down_arrow">
                    </div>
                  </template>
                  <template v-else>
                    <!-- カード: あり、データ: なし -->
                    <p class="limit-and-history-item-text-no-data">チャージ残高は０円です。</p>
                  </template>
                </div>
              </div>
            </div>
            <!-- ご利用履歴 -->
            <div class="limit-and-history-wrapper">
              <div class="limit-and-history-content">
                <p class="limit-and-history-title">ご利用履歴</p>
                <div v-if="this.chargeUsageMinimumList.length">
                  <template v-if="!this.isShowMoreChargeUsageList">
                    <!-- もっと見る 前 最大 3 件 -->
                    <template v-for="(item, i) in this.chargeUsageMinimumList" :key="i">
                        <div :class="[
                          { 'history-item-wrapper': i !== this.chargeUsageMinimumList.length - 1 },
                          { 'history-item-last-wrapper': i === this.chargeUsageMinimumList.length - 1 }
                        ]">
                        <div class="limit-and-history-item-content">
                          <span class="limit-and-history-item-text-date">{{dateFormat(item.usage_datetime)}} {{settlementKbn(item.settlement_kbn)}}</span>
                          <span class="limit-and-history-item-text-value">{{ plusOrMinusSign(item.settlement_kbn) }}{{$filters.addComma(chargeUsageValue(item))}}円分</span>
                        </div>
                      </div>
                    </template>
                  </template>
                  <template v-else>
                    <!-- もっと見る 後 最大件数表示 -->
                    <template v-for="(item, i) in this.chargeUsageMaximumList" :key="'0'+i">
                      <div :class="[
                        { 'history-item-wrapper': i !== this.chargeUsageMaximumList.length - 1 },
                        { 'history-item-last-wrapper': i === this.chargeUsageMaximumList.length - 1 }
                      ]">
                        <div class="limit-and-history-item-content">
                          <span class="limit-and-history-item-text-date">{{dateFormat(item.usage_datetime)}} {{settlementKbn(item.settlement_kbn)}}</span>
                          <span class="limit-and-history-item-text-value">{{ plusOrMinusSign(item.settlement_kbn) }}{{$filters.addComma(chargeUsageValue(item))}}円分</span>
                        </div>
                      </div>
                    </template>
                  </template>
                  <div class="show-more-wrapper" v-if="showMoreChargeUsageList" v-show="!this.isShowMoreChargeUsageList">
                    <button class="history-show-more-button" v-on:click="doShowMoreChargeUsageList()">もっと見る</button>
                    <img src="/lib/images/down_arrow.svg" alt="down_arrow">
                  </div>
                </div>
                <div v-else>
                  <p class="limit-and-history-item-text-no-data">ご利用履歴はありません。</p>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <!-- ---------- 初回特典がONかつ初回特典未受領の場合 ------------>
            <div class="initial-benefit-unused-wrapper">
              <div class="initial-benefit-unused-content">
                <p class="initial-benefit-unused-content-title">残高</p>
                <div class="initial-benefit-unused-content-balance-wrapper">
                  <span class="initial-benefit-unused-content-balance-number">0</span>
                  <span class="initial-benefit-unused-content-balance-unit">円分</span>
                </div>
                <div class="initial-benefit-unused-content-note-wrapper">
                  <p class="initial-benefit-unused-content-note-icon"><img src="/lib/images/note.svg" alt="note"></p>
                  <p class="initial-benefit-unused-content-note-text">まずはお試し分をお受け取りください</p>
                </div>
                <div class="initial-benefit-unused-store-type-wrapper">
                  <span class="initial-benefit-unused-store-type-text">{{ this.storeType }}</span>
                </div>
                <div class="initial-benefit-unused-button-wrapper">
                  <button class="initial-benefit-unused-button-use" disabled>
                    <img src="/lib/images/disabled-qr-icon.svg" alt="disabled-qr-icon">
                    <span>使用する</span>
                  </button>
                  <button class="initial-benefit-unused-button-charge" disabled>
                    <img src="/lib/images/add-disabled-icon.svg" alt="add-disabled-icon">
                    <span>残高チャージ</span>
                  </button>
                  <button class="initial-benefit-unused-button-benefit-use" v-bind:disabled="processing" v-on:click="this.openInitialBenefit(false)">
                    <img src="/lib/images/present-icon.svg" alt="present-icon">
                    <span>お試し分受け取り</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- ---------- メアド未登録の場合 ------------>
        <div v-else>
          <div class="not-email-registered-wrapper">
            <div class="not-email-registered-content">
              <!-- 初回特典がONの場合は表示する -->
              <div v-if="this.carwashSettings.carwash_initial_benefit_charges_flag">
                <span class="not-email-registered-content-title">お試し</span>
                <div class="not-email-registered-content-balance-wrapper">
                  <span class="not-email-registered-content-balance-number">{{$filters.addComma(this.carwashSettings.initial_benefit_value)}}</span>
                  <span class="not-email-registered-content-balance-unit">円分</span>
                </div>
                <p class="not-email-registered-content-note-text">お試しでお使いいただけます</p>
              </div>
              <div class="not-email-registered-button-wrapper">
                <button class="not-email-registered-button-benefit-use" v-bind:disabled="processing" v-on:click="goToEmailRegister()">
                  <img src="/lib/images/person.svg" alt="person">
                  <span>会員登録して使用する</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- ---------- 洗車非対応点の場合 ---------- -->
      <div v-else>
        <div class="unsupported-store-wrapper">
          <div class="unsupported-store-content">
            <div><img src="/lib/images/sorry.svg" alt="sorry"></div>
            <div class="unsupported-store-content-staff-icon"><img src="/lib/images/staff.svg" alt="carwash_not_supported"></div>
            <div class="unsupported-store-text">
              <span>この店舗では洗車プリペイドは</span><br>
              <span>ご利用になれません</span>
            </div>
          </div>
        </div>
      </div>
      <!-- ユーザーガイド -->
      <div class="userguide-wrapper">
        <div class="userguide-content">
          <a class="userguide-item" @click="goToUserGuide('V2UserGuideExplanation')">
            <span class="userguide-text">洗車プリペイドとは？</span><span><img src="/lib/images/right_arrow_green.svg" alt="right_arrow"></span>
          </a>
          <a class="userguide-item" @click="goToUserGuide('V2UserGuidePrice')">
            <span class="userguide-text">洗車コース</span><span><img src="/lib/images/right_arrow_green.svg" alt="right_arrow"></span>
          </a>
          <a class="userguide-item" @click="goToUserGuide('V2UserGuideQuestionAndAnswer')">
            <span class="userguide-text">よくあるご質問</span>
            <span><img src="/lib/images/right_arrow_green.svg" alt="right_arrow"></span>
          </a>
          <a class="userguide-item-last" @click="goToUserGuide('V2UserGuideTerms')">
            <span class="userguide-text">利用規約</span>
            <span><img src="/lib/images/right_arrow_green.svg" alt="right_arrow"></span>
          </a>
        </div>
      </div>
      <!-- QR -->
      <div class="modal_overlay" v-if="this.isOpenQR">
        <div class="modal_container">
          <div class="qr-modal-content">
              <div class="qr-modal-qr-wrapper">
                <div class="qr-modal-qr-content" @touchstart="qrTouchStart" @touchmove="qrTouchMove" @touchend="qrTouchEnd">
                  <div class="qr-modal-qr-first">
                    <div id="first-qrcode"></div>
                    <div class="qr-modal-qr-text-wrapper">
                      <span class="qr-modal-qr-text-number1">1</span>
                      <span class="qr-modal-qr-text-color">青色</span>
                    </div>
                  </div>
                  <div class="qr-modal-qr-arrow-wrapper">
                    <div><img src="/lib/images/left_arrow_gray_double.svg" alt="left_arrow_gray_double"></div>
                    <div><span class="qr-modal-qr-arrow-text">左へ</span></div>
                  </div>
                  <div class="qr-modal-qr-second">
                    <div id="second-qrcode"></div>
                    <div class="qr-modal-qr-text-wrapper">
                      <span class="qr-modal-qr-text-number2">2</span>
                      <span class="qr-modal-qr-text-color">緑色</span>
                    </div>
                  </div>
                </div>
              </div>
            <div class="qr-modal-qr-text-note-wrapper">
              <p class="qr-modal-qr-text-note">
                注文機の読み取り口に<br>
                QRコードをかざしてください
              </p>
              <p class="qr-modal-qr-text-note-sub">読み込み後にスワイプしてください</p>
            </div>
            <div class="qr-modal-close-button-wrapper">
              <div class="qr-modal-close-button" @click="closeQR">
                <img class="qr-modal-close-button-icon" src="/lib/images/cross.svg" alt="cross">
                <button class="qr-modal-close-button-text">閉じる</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 店舗選択プルダウン -->
      <div class="modal_overlay" v-if="this.isOpenSSSelector">
        <div class="modal_container">
          <div class="store-selector-modal-content">
            <div class="store-selector-modal-title">
              <img class="store-selector-modal-title-img" src="/lib/images/star.svg" alt="star">
              <span class="store-selector-modal-title-text">お気に入り店舗</span>
            </div>
            <div class="store-selector-modal-list">
              <!-- マイSSをリスト表示 -->
              <div v-for="(ss, index) in this.mySSList" :key="ss.code">
                <button
                  :class="[
                    { 'store-selector-modal-item': index !== this.mySSList.length - 1 },
                    { 'store-selector-modal-item-last': index === this.mySSList.length - 1 }
                  ]"
                  v-bind:disabled="processing"
                  @click="changeStore(ss.code)"
                >
                  <span class="store-selector-modal-item-text">{{ ss.name }}</span>
                  <span class="store-selector-modal-item-icon"><img src="/lib/images/right_arrow_green.svg" alt="right_arrow"></span>
                </button>
              </div>
            </div>
            <div class="store-selector-modal-close-button-wrapper">
              <div class="store-selector-modal-close-button">
                <img class="store-selector-modal-close-button-icon" src="/lib/images/cross.svg" alt="cross">
                <button class="store-selector-modal-close-button-text" @click="closeSSSelector">閉じる</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 初回特典ポップアップ -->
      <div class="modal_overlay" v-if="this.isOpenInitialBenefitPopup">
        <div class="modal_container">
          <div class="initial-benefit-popup-content">
            <div class="initial-benefit-popup-content-img">
              <img src="/lib/images/present-color.svg" alt="present-color">
            </div>
            <div>
              <!-- 自動で表示されるモーダルの場合 -->
              <div v-if="this.isAutoDisplayInitialBenefitPopup">
                <h2 class="initial-benefit-popup-content-title">
                  お試し{{$filters.addComma(this.carwashSettings.initial_benefit_value)}}円分をプレゼント
                </h2>
                <h2 class="initial-benefit-popup-content-title-sub">
                  「{{this.ssInfo.ss_name}}」で使いますか？
                </h2>
                <p class="initial-benefit-popup-content-sentence">
                  プレゼント分残高は、別の店舗ではご利用いただけません、別の店舗でご利用したい場合は、一度キャンセルをしてお気に入り店舗を変更後、TOP画面より「洗車」→「お試し分受取り」の手順でお進みください。
                </p>
              </div>
              <!-- 手動で表示されるモーダルの場合 -->
              <div v-else>
                <h2 class="initial-benefit-popup-content-title-sub">
                  お試し{{$filters.addComma(this.carwashSettings.initial_benefit_value)}}円分を<br>
                  「{{this.ssInfo.ss_name}}」で使いますか？
                </h2>
                <p class="initial-benefit-popup-content-sentence">
                  プレゼント分残高は、別の店舗ではご利用いただけません。別の店舗でご利用したい場合は、一度キャンセルをしてお気に入り店舗を選択し直してください。
                </p>
              </div>
              <p class="initial-benefit-popup-content-sentence-sub">
                ※ 有効期限は、受け取り後180日です。
              </p>
            </div>
            <button v-bind:disabled="processing" v-on:click="doInitialBenefitCharge()" class="initial-benefit-popup-content-button-use">
              <span>この店舗で使う</span>
              <img src="/lib/images/right_arrow_white.svg" alt="right_arrow_white">
            </button>
            <button v-bind:disabled="processing" v-on:click="closeInitialBenefit()" class="initial-benefit-popup-content-button-cancel">
              <img src="/lib/images/cross_green.svg" alt="cross_green">
              <span>キャンセル</span>
            </button>
            <div v-if="this.isAutoDisplayInitialBenefitPopup" class="initial-benefit-popup-content-checkbox-wrapper">
              <input type="checkbox"
                    id="initial-benefit-popup-content-checkbox"
                    v-model="doNotShowAgain"
                    @change="handleCheckboxChange">
              <label for="initial-benefit-popup-content-checkbox">今後、このメッセージを表示しない</label>
            </div>
            <div class="initial-benefit-popup-content-close-button-wrapper">
              <div class="initial-benefit-popup-content-close-button" @click="closeInitialBenefit()">
                <img class="initial-benefit-popup-content-close-button-icon" src="/lib/images/cross.svg" alt="cross">
                <button class="initial-benefit-popup-content-close-button-text">閉じる</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import carwashSettingsApi from '@/store/Api/carwashSettings'
import prepaidCardApi from '@/store/Api/prepaidCard'
import prepaidCardChargeUsedHistoryApi from '@/store/Api/prepaidCardChargeUsedHistory'
import prepaidCardInitialBenefitChargeApi from '@/store/Api/prepaidCardInitialBenefitCharge'
import ssApi from '@/store/Api/ss'
import Loading from '@/views/v2/Loading'
import modal from '@/assets/v2/modal'
import moment from 'moment'
import config from '@/commons/v2/config'
import getMySSListApi from '@/store/Api/getMySSList'
import changeMySSApi from '@/store/Api/changeMySS'
import carwashQrApi from '@/store/Api/carwashQr'
import getIntecQrApi from '@/store/Api/getIntecQr'
import gmoCardEditGet from '@/store/Api/gmoCardEditGet'
import QRCode from 'qrcodejs2'
import axios from 'axios'
import { useGmoPageStore } from '@/store/gmoPage'

const INITIAL_BENEFIT_USED_STATUS = {
  NOT_USED: 0,
  USED: 1
}

const RESPONSE_STATUS = {
  NOT_FOUND: 404
}

export default {
  data () {
    return {
      loading: true,
      isCarwashSupported: false,
      cardExists: false,
      ssInfo: [],
      isShowMorePrepaidCardList: false,
      isShowMoreChargeUsageList: false,
      modalActive: false,
      processing: false,
      createdPrepaidCard: {
        card_no: null,
        pin_cd: null
      },
      // 初回特典の利用状況(0: 未使用, 1: 使用済み)
      initialBenefitUsed: 0,
      isOpenInitialBenefitPopup: false,
      isAutoDisplayInitialBenefitPopup: false,
      doNotShowAgain: false,
      isOpenSSSelector: false,
      isOpenQR: false,
      bestMySS: null,
      mySSList: [],
      oneTimeCode: '',
      bcleQrCode: '',
      firstQRCode: null,
      secondQRCode: null,
      touchStartX: 0,
      touchEndX: 0,
      isSlideLeft: false
    }
  },
  methods: {
    ...mapActions('PREPAID_CARD', [
      'setPrepaidCard'
    ]),
    ...mapActions('PREPAID_CARD_CHARGE_USED_HISTORY', [
      'setPrepaidCardChargeUsedHistory'
    ]),
    ...mapActions('CARWASH_SETTINGS', [
      'setCarwashSettings'
    ]),
    setSsInfo (ssInfo) {
      this.ssInfo = ssInfo
    },
    setMySSList (mySSList) {
      this.mySSList = mySSList
    },
    setBestMySS (bestMySS) {
      this.bestMySS = bestMySS
    },
    setCreatedPrepaidCard (prepaidCard) {
      this.createdPrepaidCard = prepaidCard
    },
    setInitialBenefitUsed (initialBenefitUsed) {
      this.initialBenefitUsed = initialBenefitUsed
    },
    openErrorModal (message) {
      modal.alert(message)
    },
    doShowMorePrepaidCardList () {
      // [eventTrack]
      this.nativeEVENTSet('CarWashHistoryButton', 'SEE_MORE_YUKOKIGEN', 'TAP')
      this.isShowMorePrepaidCardList = true
    },
    doShowMoreChargeUsageList () {
      // [eventTrack]
      this.nativeEVENTSet('CarWashHistoryButton', 'SEE_MORE_HISTORY', 'TAP')
      this.isShowMoreChargeUsageList = true
    },
    async openQR () {
      // モーダルを表示
      this.isOpenQR = true
      this.modalActive = true

      // DOMの更新を確実に待つために setTimeout を使用
      await this.$nextTick()
      setTimeout(() => {
        this.initializeQRCode()
      }, 300)
    },
    initializeQRCode () {
      try {
        // QRコード要素の存在確認
        const firstQRElement = document.getElementById('first-qrcode')
        const secondQRElement = document.getElementById('second-qrcode')

        if (!firstQRElement || !secondQRElement) {
          console.error('QRコード要素が見つかりません')
          return
        }

        // JavaScriptインターフェースで画面を明るくする
        this.nativeQrLight()

        // QRコードの色とレベルを設定
        const colorDark = '#000000'
        const colorLight = '#ffffff'
        const correctLevel = QRCode.CorrectLevel.L
        let oneTimeCodeQrSizePx = null
        let bcleQrSizePx = null

        // QRのサイズをOSごとに定義
        if (this.nativeData.platform === 'iOS') {
          // iOSは固定のピクセル値
          // ワンタイムコードQRコードのサイズ(ピクセル)
          oneTimeCodeQrSizePx = 186
          // ビークルQRコードのサイズ(ピクセル)
          bcleQrSizePx = 186
        } else if (this.nativeData.platform === 'Android') {
          // Androidは物理的に表示したいミリメートルを指定し、
          // それをピクセルに変換する。
          // ワンタイムコードQRコードのサイズ(ミリメートル)
          const oneTimeCodeQrSizeMM = 28.5
          // ワンタイムコードQRコードのサイズ(ピクセル)
          oneTimeCodeQrSizePx = this.mmToPixels(oneTimeCodeQrSizeMM)
          // ビークルQRコードのサイズ(ミリメートル)
          const bcleQrSizeMM = 29.0
          // ビークルQRコードのサイズ(ピクセル)
          bcleQrSizePx = this.mmToPixels(bcleQrSizeMM)
        }

        // ワンタイムコードのQRコードを生成する
        firstQRElement.innerHTML = ''
        this.firstQRCode = new QRCode(firstQRElement, {
          text: this.oneTimeCode,
          width: oneTimeCodeQrSizePx,
          height: oneTimeCodeQrSizePx,
          colorDark,
          colorLight,
          correctLevel
        })

        // ビークルQRコードを生成する
        secondQRElement.innerHTML = ''
        this.secondQRCode = new QRCode(secondQRElement, {
          text: this.bcleQrCode,
          width: bcleQrSizePx,
          height: bcleQrSizePx,
          colorDark,
          colorLight,
          correctLevel
        })

        // イベントトラッキング
        this.nativePVset('CARWASH_QR')
      } catch (error) {
        console.error('QRコード初期化エラー:', error)
        this.closeQR()
      }
    },
    // ミリメートルをピクセルに変換する関数
    mmToPixels (mm) {
      // mmをインチに変換後、DPIをかけて物理ピクセル数を算出(1インチは25.4mm)
      const physicalPixels = Math.round((mm / 25.4) * this.nativeData.dpi)

      // 物理ピクセルをデバイスピクセル比で割って論理ピクセルを算出
      const logicalPixels = physicalPixels / this.nativeData.devicePixelRatio

      return logicalPixels
    },
    closeQR () {
      this.isOpenQR = false
      this.modalActive = false
      // JavaScriptインターフェースで画面を暗くする
      this.nativeRevertBrightness()
    },
    qrTouchStart (event) {
      this.touchStartX = event.touches[0].clientX
    },
    qrTouchMove (event) {
      this.touchEndX = event.touches[0].clientX
    },
    qrTouchEnd () {
      const qrWidth = document.querySelector('.qr-modal-qr-first').offsetWidth // QRコードの幅を取得
      const swipeDistance = this.touchStartX - this.touchEndX
      const swipePercentage = (swipeDistance / qrWidth) * 100 // スワイプ距離をパーセンテージで計算

      // スワイプが30%を超えた場合に切り替える
      if (swipePercentage > 30) {
        // 左スワイプ（2つ目のQRコードを表示）
        this.isSlideLeft = true
        // [eventTrack]
        this.nativeEVENTSet('CarWashCouponButton', 'SWIPE_QR', 'SWIPE')
      } else if (swipePercentage < -30) {
        // 右スワイプ（1つ目のQRコードを表示）
        this.isSlideLeft = false
      }
    },
    closeInitialBenefit () {
      // [eventTrack]
      this.nativeEVENTSet('HistoryChargePopupButton', 'CANCEL_SYOKAI_TOKUTEN', 'TAP')
      this.isOpenInitialBenefitPopup = false
      this.modalActive = false
    },
    openInitialBenefit (isAutoDisplay) {
      // [eventTrack]
      this.nativePVset('HISTORY_CARWASH_SYOKAI_CHARGE_POPUP')
      window.scrollTo(0, 0)
      this.isAutoDisplayInitialBenefitPopup = isAutoDisplay
      this.isOpenInitialBenefitPopup = true
      this.modalActive = true
    },
    openSSSelector () {
      this.isOpenSSSelector = true
      this.modalActive = true
    },
    closeSSSelector () {
      this.isOpenSSSelector = false
      this.modalActive = false
    },
    // 初回特典受領ポップアップを出すかどうかの判断
    async isShowInitialBenefitPopup () {
      // ネイティブから「次から表示しないチェックボックス」の値を取得
      // ネイティブから取得した値をセッションストレージに保存します。
      this.nativeGetCarwashInitialBenefitDialogDoNotShow()

      // nativeGetCarwashInitialBenefitDialogDoNotShow()の実行で
      // ネイティブからJSのsendCarwashInitialBenefitDialogDoNotShow()が実行され、
      // セッションストレージに値を格納するため少し待つ
      await new Promise(resolve => setTimeout(resolve, 500))

      // セッションストレージから「次から表示しないチェックボックス」の値を取得
      let carwashInitialBenefitDialogDoNotShow = sessionStorage.getItem('carwashInitialBenefitDialogDoNotShow')
      // セッションストレージに値がない場合は、初期値をセット
      if (carwashInitialBenefitDialogDoNotShow === null) {
        sessionStorage.setItem('carwashInitialBenefitDialogDoNotShow', 'false')
        carwashInitialBenefitDialogDoNotShow = 'false'
      }

      // 1.初回特典設定がON
      // 2.初回特典を利用していない
      // 3.ログイン済
      // 4.「次から表示しないチェックボックス」がOFF
      // 5.選択SSが洗車対応店舗
      if (
        this.carwashSettings.carwash_initial_benefit_charges_flag &&
        !this.initialBenefitUsed &&
        this.isEmailRegistered &&
        carwashInitialBenefitDialogDoNotShow === 'false' &&
        this.isCarwashSupported
      ) {
        return true
      }
      return false
    },
    handleCheckboxChange () {
      // チェックボックスの値をネイティブのストレージに保存
      this.nativeSetCarwashInitialBenefitDialogDoNotShow(this.doNotShowAgain)
    },
    // メアド登録画面へ遷移する関数
    goToEmailRegister () {
      // [eventTrack]
      this.nativeEVENTSet('CarWashButton', 'MOVED_TOUROKU_SENTAKU', 'TAP')

      // URL
      const url = `https://${process.env.VUE_APP_INTEC_DOMAIN}/web/BCL0204.aspx`
      // クエリパラメータを追加したURL
      const params = `?tsid=${this.nativeData.tsid}&ot=${this.nativeData.otoken}&frm=carwash&btnfrm=carwash`

      // インテック社のメールアドレス登録画面へ遷移
      axios.get(url + params, {
        headers: {
          'X-CLS-App-Version': this.xClsAppVersion
        }
      }).then(response => {
        // URLを取得
        const finalUrl = response.request.responseURL
        // ベースURLを構築
        const baseUrl = new URL(finalUrl).origin + new URL(finalUrl).pathname.substring(0, new URL(finalUrl).pathname.lastIndexOf('/') + 1)

        // HTMLのheadタグにbaseタグを追加
        let htmlContent = response.data
        htmlContent = htmlContent.replace('<head>', `<head><base href="${baseUrl}">`)

        // HTML内容をページに書き込む
        document.open()
        document.write(htmlContent)
        document.close()

        // ブラウザの履歴とURLを更新
        history.pushState({}, '', finalUrl)
      }).catch(error => {
        console.log('Navigation error:', error)
      })
    },
    goToUserGuide (name) {
      this.$router.push({
        name,
        query: {
          tsid: this.nativeData.tsid,
          popinfoid: this.nativeData.popinfoid,
          otoken: this.nativeData.otoken,
          authid: this.nativeData.authid,
          ss_code: this.nativeData.ss_code,
          x_cls_app_version: this.nativeData.appVersion,
          x_cls_os: this.nativeData.platform,
          x_cls_os_version: this.nativeData.osVersion,
          dpi: this.nativeData.dpi,
          device_pixel_ratio: this.nativeData.devicePixelRatio
        }
      })
      // スクロール位置を初期化する。
      window.scrollTo(0, 0)
    },
    nextPage (isButtonTap = true) {
      if (isButtonTap) {
        // [eventTrack]
        this.nativeEVENTSet('CarWashChargeButton', 'MOVED_CHARGE', 'TAP')
      }

      // DT洗車 利用規約表示 恒久対応
      // ref: https://gitlab.ssl.iridge.jp/cosmo-oil/carwash-front/-/issues/34
      if (this.cardExists && this.prepaidCardChargeUsedHistory.normal_charged === config.CHARGE_USED_HISTORY_NORMAL_CHARGED_CHARGED) {
        // カードが存在し、過去に決済済みなので、チャージ画面へ
        this.toCharge()
      } else {
        // カードが存在しない、または、カード発行済みだがまだ決済したことがないため、初回規約画面へ
        this.toAgreement()
      }
    },
    toAgreement () {
      // 初回利用同意画面へ遷移
      this.$router.push({
        name: 'V2InitialAgreement',
        query: {
          tsid: this.nativeData.tsid,
          otoken: this.nativeData.otoken,
          popinfoid: this.nativeData.popinfoid,
          authid: this.nativeData.authid,
          ss_code: this.nativeData.ss_code,
          card_no: this.prepaidCard.card_info.card_no,
          pin_cd: this.prepaidCard.card_info.pin_cd,
          x_cls_app_version: this.nativeData.appVersion,
          x_cls_os: this.nativeData.platform,
          x_cls_os_version: this.nativeData.osVersion,
          dpi: this.nativeData.dpi,
          device_pixel_ratio: this.nativeData.devicePixelRatio
        }
      })
    },
    toCharge () {
      // チャージ画面へ遷移
      this.$router.push({
        name: 'V2Charge',
        query: {
          tsid: this.nativeData.tsid,
          otoken: this.nativeData.otoken,
          popinfoid: this.nativeData.popinfoid,
          authid: this.nativeData.authid,
          ss_code: this.nativeData.ss_code,
          card_no: this.prepaidCard.card_info.card_no,
          pin_cd: this.prepaidCard.card_info.pin_cd,
          x_cls_app_version: this.nativeData.appVersion,
          x_cls_os: this.nativeData.platform,
          x_cls_os_version: this.nativeData.osVersion,
          dpi: this.nativeData.dpi,
          device_pixel_ratio: this.nativeData.devicePixelRatio
        }
      })
    },
    reload (query) {
      const r = this.$router.resolve({
        name: this.$route.name,
        params: this.$route.params,
        query
      })
      console.log(r.href)
      window.location.assign(r.href)
    },
    async doInitialBenefitCharge () {
      // 二度押しロック
      this.processing = true
      let isApiError = false
      // [eventTrack]
      this.nativeEVENTSet('HistoryChargePopupButton', 'USE_SYOKAI_TOKUTEN', 'TAP')

      if (this.cardExists) {
        // カードが存在するので、初回特典チャージのみ
        const postData = {
          card_no: this.prepaidCard.card_info.card_no,
          pin_cd: this.prepaidCard.card_info.pin_cd,
          charge_value_amount: this.carwashSettings.initial_benefit_value
        }

        await prepaidCardInitialBenefitChargeApi.post(this.nativeData.authid, this.nativeData.ss_code, postData).then(res => {
          // リロード
          const query = {
            tsid: this.nativeData.tsid,
            otoken: this.nativeData.otoken,
            popinfoid: this.nativeData.popinfoid,
            authid: this.nativeData.authid,
            ss_code: this.nativeData.ss_code,
            x_cls_app_version: this.nativeData.appVersion,
            x_cls_os: this.nativeData.platform,
            x_cls_os_version: this.nativeData.osVersion,
            dpi: this.nativeData.dpi,
            device_pixel_ratio: this.nativeData.devicePixelRatio
          }
          this.reload(query)
        }).catch(e => { // eslint-disable-line no-unused-vars
          console.log('prepaidCardInitialBenefitChargeApiPost-error')
          if (!isApiError) {
            this.openErrorModal('エラーが発生しました。')
            isApiError = true
          }
          // 二度押しロック解除
          this.processing = false
        })
      } else {
        // カードが存在しないので、プリペイドカード新規発行
        await prepaidCardApi.post(this.nativeData.authid, this.nativeData.ss_code).then(res => {
          this.setCreatedPrepaidCard(res.data.body)
        }).catch(e => { // eslint-disable-line no-unused-vars
          console.log('prepaidCardApiPost-error')
          if (!isApiError) {
            this.openErrorModal('エラーが発生しました。')
            isApiError = true
          }
          // 二度押しロック解除
          this.processing = false
        })

        if (!isApiError) {
          // 発行したプリペイドカードで初回特典チャージ
          const postData = {
            card_no: this.createdPrepaidCard.card_no,
            pin_cd: this.createdPrepaidCard.pin_cd,
            charge_value_amount: this.carwashSettings.initial_benefit_value
          }
          await prepaidCardInitialBenefitChargeApi.post(this.nativeData.authid, this.nativeData.ss_code, postData).then(res => {
            // リロード
            const query = {
              tsid: this.nativeData.tsid,
              otoken: this.nativeData.otoken,
              popinfoid: this.nativeData.popinfoid,
              authid: this.nativeData.authid,
              ss_code: this.nativeData.ss_code,
              x_cls_app_version: this.nativeData.appVersion,
              x_cls_os: this.nativeData.platform,
              x_cls_os_version: this.nativeData.osVersion,
              dpi: this.nativeData.dpi,
              device_pixel_ratio: this.nativeData.devicePixelRatio
            }
            this.reload(query)
          }).catch(e => { // eslint-disable-line no-unused-vars
            console.log('prepaidCardInitialBenefitChargeApi-error')
            if (!isApiError) {
              this.openErrorModal('エラーが発生しました。')
              isApiError = true
            }
            // 二度押しロック解除
            this.processing = false
          })
        }
      }
    },
    // カード編集をクリック
    async doEdit () {
      // [eventTrack]
      this.nativeEVENTSet('CarWashEditButton', 'MOVED_EDIT_CARD', 'TAP', { authId: 'authId' })

      this.processing = true
      await gmoCardEditGet.post(this.nativeData.authid).then(res => {
        const gmoUrl = res.data
        // 戻るボタンの出し分け
        this.appDisplayBack(false)
        // GMO決済画面
        const gmoPageStore = useGmoPageStore()
        gmoPageStore.gmoUrl = gmoUrl
        this.$router.push({
          name: 'V2CardEdit',
          query: {
            tsid: this.nativeData.tsid,
            otoken: this.nativeData.otoken,
            popinfoid: this.nativeData.popinfoid,
            authid: this.nativeData.authid,
            ss_code: this.nativeData.ss_code,
            card_no: this.prepaidCard.card_info.card_no,
            pin_cd: this.prepaidCard.card_info.pin_cd,
            x_cls_app_version: this.nativeData.appVersion,
            x_cls_os: this.nativeData.platform,
            x_cls_os_version: this.nativeData.osVersion,
            dpi: this.nativeData.dpi,
            device_pixel_ratio: this.nativeData.devicePixelRatio
          }
        })
      }).catch(e => {
        console.log('gmoCardEditGetApiPost-error')
        // 二度押しロック解除
        this.processing = false
      })
    },
    dateFormat: function (date) {
      return moment(date).format('YYYY.MM.DD')
    },
    daysRemaining: function (date) {
      const now = moment()
      return moment(date).diff(now, 'days')
    },
    settlementKbn: function (settlement_kbn) {
      if (settlement_kbn === config.CARD_USAGE_SETTLEMENT_KBN_VALUE_CHARGED) {
        return '残高チャージ'
      } else if (settlement_kbn === config.CARD_USAGE_SETTLEMENT_KBN_VALUE_USED) {
        return '洗車'
      }
      return ''
    },
    chargeUsageValue: function (history) {
      if (history.settlement_kbn === config.CARD_USAGE_SETTLEMENT_KBN_VALUE_CHARGED) {
        // バリューチャージ
        return history.charge_designated_limit_value
      } else if (history.settlement_kbn === config.CARD_USAGE_SETTLEMENT_KBN_VALUE_USED) {
        // バリュー利用
        return history.usage_limit_value_amount
      }
      return ''
    },
    plusOrMinusSign: function (settlement_kbn) {
      if (settlement_kbn === config.CARD_USAGE_SETTLEMENT_KBN_VALUE_CHARGED) {
        return '+'
      } else if (settlement_kbn === config.CARD_USAGE_SETTLEMENT_KBN_VALUE_USED) {
        return '-'
      }
      return ''
    },
    changeStore: async function (ss_code) {
      // 二度押しロック
      this.processing = true
      let isApiError = false

      // パラメータの処理区分の設定 0:追加、1:更新、2:削除
      const procdiv = 1
      // パラメータのマイSS区分の設定 1:ベストマイSS、2:マイSS
      const mysskbn = 1

      // マイSS登録・更新APIをコール
      await changeMySSApi.put(this.xClsAppVersion, this.nativeData.tsid, this.nativeData.otoken, procdiv, ss_code, mysskbn).then(res => {
        // リロード
        const query = {
          tsid: this.nativeData.tsid,
          otoken: this.nativeData.otoken,
          popinfoid: this.nativeData.popinfoid,
          authid: this.nativeData.authid,
          // SSコードは変更後のSSコードを設定
          ss_code,
          x_cls_app_version: this.nativeData.appVersion,
          x_cls_os: this.nativeData.platform,
          x_cls_os_version: this.nativeData.osVersion,
          dpi: this.nativeData.dpi,
          device_pixel_ratio: this.nativeData.devicePixelRatio
        }
        this.reload(query)
      }).catch(e => {
        if (!isApiError) {
          this.openErrorModal('エラーが発生しました。')
          isApiError = true
        }
        // 二度押しロック解除
        this.processing = false
      })
    }
  },
  computed: {
    ...mapGetters('PREPAID_CARD', [
      'prepaidCard'
    ]),
    ...mapGetters('PREPAID_CARD_CHARGE_USED_HISTORY', [
      'prepaidCardChargeUsedHistory'
    ]),
    ...mapGetters('CARWASH_SETTINGS', [
      'carwashSettings'
    ]),
    nativeData: function () {
      const getData = {}
      // ネイティブから取得したクエリパラメータを格納する。
      getData.tsid = this.$route.query.tsid
      getData.popinfoid = this.$route.query.popinfoid
      getData.otoken = this.$route.query.otoken
      getData.authid = this.$route.query.authid
      getData.ss_code = this.$route.query.ss_code
      getData.appVersion = this.$route.query.x_cls_app_version
      getData.platform = this.$route.query.x_cls_os
      getData.osVersion = this.$route.query.x_cls_os_version
      getData.goToCharge = this.$route.query.go_to_charge
      getData.dpi = this.$route.query.dpi
      getData.devicePixelRatio = this.$route.query.device_pixel_ratio
      return getData
    },
    // X-CLS-App-Versionを作る
    xClsAppVersion: function () {
      return this.nativeData.appVersion + '/' + this.nativeData.platform + '/' + this.nativeData.osVersion
    },
    // 店舗名の長さに基づいてクラスを返す
    getStoreNameClass () {
      const name = this.bestMySS?.name || ''
      if (name.length > 20) {
        return 'store-name-xsmall'
      } else if (name.length > 15) {
        return 'store-name-small'
      } else if (name.length > 10) {
        return 'store-name-medium'
      }
      return ''
    },
    // メアド登録済みユーザーかどうか
    isEmailRegistered: function () {
      // Undefinedの場合はfalse
      if (typeof this.nativeData.authid === 'undefined') {
        return false
      }

      // 空文字の場合はfalse
      if (this.nativeData.authid === '') {
        return false
      }

      // それ以外の場合はtrue
      return true
    },
    // 店舗種別を返す
    storeType: function () {
      if (this.ssInfo.dt_carwash_flag === 1 && this.ssInfo.hand_carwash_flag === 1) {
        return '手洗い・機械洗車、ドライブスルー洗車　対応店舗'
      } else if (this.ssInfo.dt_carwash_flag === 1) {
        return 'ドライブスルー洗車　対応店舗'
      } else if (this.ssInfo.hand_carwash_flag === 1) {
        return '手洗い・機械洗車　対応店舗'
      }
      return ''
    },
    // 有効期限リスト
    prepaidCardList: function () {
      const limitValueList = this.prepaidCard.card_info.limit_value_list ?? []
      // バリュー有効期限日時 の 昇順
      return limitValueList.sort(function (a, b) {
        if (a.value_expire_datetime < b.value_expire_datetime) return -1
        if (a.value_expire_datetime > b.value_expire_datetime) return 1
        return 0
      })
    },
    // 一番近い有効期限の日付を返す
    nearestLimitValueDate: function () {
      // リストが空の場合はnullを返す
      if (!this.prepaidCardList || this.prepaidCardList.length === 0) {
        return null
      }
      return this.prepaidCardList[0].value_expire_datetime
    },
    // 有効期限の初期表示件数
    prepaidCardMinimumNum: () => 3,
    // 有効期限のxx日前に注意喚起表示
    expireWarningDaysNum: () => 31,
    // 有効期限の初期表示リスト
    prepaidCardMinimumList: function () {
      if (this.prepaidCardList) {
        return this.prepaidCardList.slice(0, this.prepaidCardMinimumNum)
      }
      return []
    },
    // 有効期限が近づいています判定
    expireWarning: function () {
      const vm = this
      return function (expireDate) {
        const warningDate = moment(expireDate).subtract(vm.expireWarningDaysNum, 'days')
        const now = moment()
        // 有効期限のxx日前を超えているか
        return now.isSameOrAfter(warningDate)
      }
    },
    // 有効期限のもっと見るボタン表示判定
    showMorePrepaidCardList: function () {
      if (this.prepaidCard.card_info.limit_value_list) {
        return this.prepaidCard.card_info.limit_value_list.length > this.prepaidCardMinimumNum
      }
      return false
    },
    // 利用履歴リスト（取引種別:020,030）
    chargeUsageList: function () {
      if (this.prepaidCardChargeUsedHistory.card_usage_info_listV2) {
        // 取引種別が020,030の利用履歴
        const cardUsageInfoListV2 = this.prepaidCardChargeUsedHistory.card_usage_info_listV2.filter(function (history) {
          return history.settlement_kbn === config.CARD_USAGE_SETTLEMENT_KBN_VALUE_CHARGED || history.settlement_kbn === config.CARD_USAGE_SETTLEMENT_KBN_VALUE_USED
        })
        // 利用日時 の 降順
        return cardUsageInfoListV2.sort(function (a, b) {
          if (a.usage_datetime > b.usage_datetime) return -1
          if (a.usage_datetime < b.usage_datetime) return 1
          return 0
        })
      }
      return []
    },
    // 利用履歴の初期表示件数
    chargeUsageMinimumNum: () => 7,
    // 利用履歴の最大表示件数
    chargeUsageMaximumNum: () => 50,
    // 利用履歴の初期表示リスト
    chargeUsageMinimumList: function () {
      return this.chargeUsageList.slice(0, this.chargeUsageMinimumNum)
    },
    // 利用履歴の最大表示リスト
    chargeUsageMaximumList: function () {
      return this.chargeUsageList.slice(0, this.chargeUsageMaximumNum)
    },
    // 利用履歴のもっと見るボタン表示判定
    showMoreChargeUsageList: function () {
      return this.chargeUsageList.length > this.chargeUsageMinimumNum
    },
    // 初回特典が利用できるかどうか
    // DT洗車設定(初回特典ステータス):true かつ
    // 初回特典を利用していないかつ
    // カードが存在しない場合は利用できる
    isAvailableInitialBenefit: function () {
      return (
        this.carwashSettings.carwash_initial_benefit_charges_flag &&
        !this.initialBenefitUsed &&
        !this.cardExists
      )
    }
  },
  async mounted () {
    // 戻るボタンの出し分け
    this.appDisplayBack(true)

    // タイトルを設定
    // 以降の画面で同じタイトルを適用する場合は、最初の画面のみ呼び出しを行えばOK。
    this.nativeSetTitle('洗車プリペイド')

    let isApiError = false

    // マイSS一覧取得APIをコール。
    await getMySSListApi.post(this.xClsAppVersion, this.nativeData.tsid, this.nativeData.otoken).then(res => {
      this.setMySSList(res.data.body.myss)
      this.setBestMySS(res.data.body.best_myss)
    }).catch(e => {
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    // SS
    await ssApi.get(this.nativeData.ss_code).then(res => {
      this.setSsInfo(res.data.body.ss_info)
      // dt_carwash_flag または hand_carwash_flag が
      // true の場合、洗車対応店舗
      const isDtCarwashStore = res.data.body.ss_info.dt_carwash_flag
      const isHandCarwashStore = res.data.body.ss_info.hand_carwash_flag
      this.isCarwashSupported = isDtCarwashStore || isHandCarwashStore
    }).catch(e => {
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    // 洗車対応店舗の場合
    if (this.isCarwashSupported) {
      // DT洗車設定情報取得
      await carwashSettingsApi.get().then(res => {
        this.setCarwashSettings(res.data)
      }).catch(e => {
        if (!isApiError) {
          this.openErrorModal('エラーが発生しました。')
          isApiError = true
        }
      })

      // DT洗車プリペイドカード情報取得
      if (this.isEmailRegistered) {
        await prepaidCardApi.get(this.nativeData.authid, this.nativeData.ss_code).then(res => {
          this.cardExists = true
          this.setPrepaidCard(res.data.body)
          // 初回特典利用有無を保持
          this.setInitialBenefitUsed(res.data.body.initial_benefit_used)
        }).catch(e => {
          if (e.response.status === RESPONSE_STATUS.NOT_FOUND) {
            // 初回特典利用有無を保持
            this.setInitialBenefitUsed(e.response.data.body.initial_benefit_used)
          } else {
            console.log('prepaidCardApi-error')
            console.log(e)
            // 404 以外のエラー
            if (!isApiError) {
              this.openErrorModal('エラーが発生しました。')
              isApiError = true
            }
          }
        })
      } else {
        this.setInitialBenefitUsed(INITIAL_BENEFIT_USED_STATUS.NOT_USED)
      }

      // カードが存在する場合
      if (this.cardExists) {
        // DT洗車バリューチャージ利用履歴取得
        await prepaidCardChargeUsedHistoryApi.get(this.nativeData.authid, this.nativeData.ss_code).then(res => {
          this.setPrepaidCardChargeUsedHistory(res.data.body)
        }).catch(e => {
          if (!isApiError) {
            this.openErrorModal('エラーが発生しました。')
            isApiError = true
          }
        })

        // DT洗車QRデータ取得 APIを呼び出す
        await carwashQrApi.get(this.nativeData.ss_code, this.nativeData.authid).then(res => {
          this.oneTimeCode = res.data.body.one_time_code
        }).catch(e => {
          if (!isApiError) {
            this.openErrorModal('エラーが発生しました。')
            isApiError = true
          }
        })

        // インテックQRコード取得APIを呼び出す
        await getIntecQrApi.get(this.nativeData.tsid, this.nativeData.otoken, this.nativeData.ss_code, this.xClsAppVersion).then(res => {
          this.bcleQrCode = res.data.body.qr_code
        }).catch(e => {
          if (!isApiError) {
            this.openErrorModal('エラーが発生しました。')
            isApiError = true
          }
        })
      }

      // ネイティブからのクエリパラメータでgo_to_chargeが渡された場合はチャージ画面へ遷移させる。
      if (
        this.isEmailRegistered &&
        typeof this.nativeData.goToCharge !== 'undefined'
      ) {
        this.nextPage(false)
        return
      }

      // 初回特典ポップアップの表示をするかどうか
      if (await this.isShowInitialBenefitPopup()) {
        this.openInitialBenefit(true)
      }
    }

    // [eventTrack]
    this.nativePVset('CARWASH_HISTORY')

    if (!isApiError) {
      this.loading = false
    }
  },
  components: {
    Loading
  }
}
</script>
